import { Navigate } from 'react-router-dom';
import { selectedUser } from '../../features/auth/authSlice';
import LoginFormComponent from '../../features/auth/components/LoginForm';
import { useAppSelector } from '../../hooks/redux/hooks';
import { emailStatuses } from '../../features/auth/models/EmailStatus.interface';

const Login = () => {
    const { isAuthenticated, verificationEmail } = useAppSelector(selectedUser);

    if (isAuthenticated && verificationEmail?.emailStatus === emailStatuses.NotVerified) {
        return <Navigate replace to='/email-verification' />
    }
    if (isAuthenticated) {
        return <Navigate replace to='/' />
    }

    return (
        <LoginFormComponent />
    )
}

export default Login;
